import { useRuleConflictPreview } from "components/modals/RuleConflictWarningModal";
import { getClassAssignmentConflictPreview } from "hooks/mutations/staff";
import { SetStaffClassTypesForm } from "shared/types";

/**
 * Gates a class-assignment save (InstructorClassTypes.tsx) behind a preview
 * of which of that instructor's near-future classes are no longer covered
 * by the PROPOSED assignment, and offers "Hapus Kelas & Simpan" to delete
 * them with the save. Purely informational otherwise (no server-side hard
 * block exists for class-type assignment). Thin wrapper over
 * useRuleConflictPreview (RuleConflictWarningModal.tsx).
 */
export const useClassAssignmentPreview = () => {
  const { checkAndConfirm, warning } = useRuleConflictPreview<SetStaffClassTypesForm>(
    getClassAssignmentConflictPreview,
    "class_assignment_conflict",
  );
  return { checkAndConfirm, classAssignmentPreviewWarning: warning };
};
